import React from 'react';

import Paragraph from 'common/components/TouchpointEditor/components/TouchpointNodes/Paragraph';

export default function CallToActionParagraph(props) {
    return <Paragraph {...props} />;
}

CallToActionParagraph.splash = {
    ...Paragraph.splash,
    defaultProps: {
        ...Paragraph.splash.defaultProps,
        meta: {
            ...Paragraph.splash.defaultProps.meta,
            // eslint-disable-next-line max-len
            content:
                'Seats are filling up fast. Reserve your spot below to gain access to the event and sessions when the big day arrives.',
        },
    },
};
